import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cart from "../components/cart/Cart";
import useOverlay from "../hooks/useOverlay";
import { CART_PATH, HOME_PATH, itemPath } from "../routes";

export default function CartPage() {
  const { open } = useOverlay();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== CART_PATH) return undefined;
    // Run after any product/search overlay restores the previous scroll position.
    const frame = requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: "instant" }));
    return () => cancelAnimationFrame(frame);
  }, [location.key, location.pathname]);
  return <Cart onClose={() => navigate(HOME_PATH)} onEditItem={(id) => open(itemPath(id))} page />;
}
